import DOMPurify from "isomorphic-dompurify";

/**
 * Return purified content
 * All html tags removed except for <a />
 *
 * `allowedTags` widens that for one call site without changing what the others
 * get. Keep it narrow: two callers sanitize user-submitted comments on the way
 * in, so anything added to the default becomes something a commenter can post.
 */

export const purify = (content: string, allowedTags: string[] = ["a"]) => {
  return (
    DOMPurify.sanitize(content, {
      ALLOWED_TAGS: allowedTags,
    }) ?? ""
  );
};
